import { connectionTypes, installationStates, integrationTypes } from '../static/constants';
import { IInstallation } from '../models';
import { mockHeaderData } from './mockHeader';

const tenantId = '7a8e7b5f-6b15-4db0-92d5-f774d230b276';
const userName = 'Mock User';

const installation = {
    state: installationStates.HEALTHY,
    isOnboarded: false,
    installationId: '1',
    allowSmartLists: true,
    authorizeUrl: 'https://google.com',
    billing: {
        hasFreePlan: true,
        hasPaidPlan: false,
        hasBought: false,
        url: 'https://apps.livestage.test.xero.com/123456/nz/subscription/customconnection/add',
    },
    versionSupport: {
        canUpdate: true,
        latestVersion: 1,
        updateRequiresAuthorization: true,
    },
};

const organisation = {
    organisationBaseCurrency: 'NZD',
    organisationClass: 'STARTER',
    organisationRegion: 'NZ',
    organisationTimezone: 'Pacific/Auckland',
    organisationPaysTax: false,
};

// /header
export const header = {
    GET: mockHeaderData(userName),
};

// /bootstrap
export const bootstrap = {
    // /bootstrap/CUSTOM
    CUSTOM: {
        GET: {
            ...organisation,
            tenantId,
            installation: {
                ...installation,
                integrationType: integrationTypes.CUSTOM,
                state: installationStates.CONNECTION_REQUIRED,
                connectionType: connectionTypes.CUSTOM,
                isOnboarded: false,
                billing: {
                    hasFreePlan: false,
                    hasPaidPlan: true,
                    hasBought: false,
                    url: 'https://apps.livestage.test.xero.com/123456/nz/subscription/customconnection/add',
                },
            } as IInstallation,
            // error: {
            //     code: 403,
            //     body: {
            //         isAdmin: true,
            //         hasRequiredPlan: false,
            //     },
            // },
        },
    },
};
